import { coreTagsGetAsyncSlice } from './get';
import { CoreTagsName } from './name';
import { createAddSyncSlice } from '@sonar-software/xuder';
import { SonarTag } from '@types';

export const coreAddTagsSyncSlice = createAddSyncSlice({
	name: CoreTagsName,
	state: coreTagsGetAsyncSlice.asyncState,
	transform: (action: SonarTag, state = []) => [ ...state, action ].sort((a, b) => a.name.localeCompare(b.name))
});
